import { SECURED_PATHS } from '../sitecore/constants';

const normalizePath = (path: string): string => {
  if (!path) return '/';
  let normalized = path;
  while (normalized.endsWith('/')) {
    normalized = normalized.slice(0, -1);
  }
  return normalized || '/';
};

export const isProtectedPath = (
  pathname: string,
  language?: string
): boolean => {
  const normalizedPath = normalizePath(pathname);

  return SECURED_PATHS.some((securedPath: string) => {
    const basePath = normalizePath(`/${securedPath}`);
    const localizedBasePath = language
      ? normalizePath(`/${language}/${securedPath}`)
      : null;

    return (
      normalizedPath === basePath ||
      (localizedBasePath && normalizedPath === localizedBasePath)
    );
  });
};
